import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'
import customColors from 'src/config/colorsV2'

export default createUseStyles(
  {
    formSections: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      paddingBottom: [8],
    },
    formSection: {
      display: 'inline-flex',
      flexDirection: 'column',
    },
    sectionTreatment: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    sectionContactDetails: {
      maxWidth: 480,
      width: '100%',
      background: customColors.white,
      marginTop: [24],
      padding: [0, 24, 24, 24],
      borderRadius: [8],
      boxShadow: '0px 0px 10px 0px rgba(33, 33, 33, 0.1)',

      [forPhoneOnly]: {
        maxWidth: 375,
        boxSizing: 'border-box',
        marginTop: [16],
        padding: [0, 16, 16, 16],
      },
    },
    restrictWidth: {
      width: 496,
      marginTop: [16],

      [forPhoneOnly]: {
        width: 343,
      },
    },
    legal: {
      display: 'block',
    },
    bookingForHeader: {
      ...typography['Lato Emphasized 1'],
      margin: [24, 0, 0, 0],
      '&:first-of-type': {
        margin: [24, 0, 0, 0],
      },
    },
    treatmentContent: {
      [forTabletPortraitUp]: {
        maxWidth: 480,
      },
    },
    inputContainer: {
      marginTop: 24,
    },
  },
  { name: 'contactScreen' }
)
